// Types matching backend API schemas

export type SignalSource = 'dom' | 'trade'
export type SignalSide = 'bid' | 'ask' | 'buy' | 'sell'
export type SignalStatus = 'active' | 'disappeared'

// DOM display mode for the dashboard. The bot always detects both types; this
// selects which are shown ("both" = all).
export type DomMode = 'precise' | 'aggregated' | 'both'

// The type a signal was detected as (a signal is never "both").
export type DomSignalType = 'precise' | 'aggregated'

export interface Signal {
  id: string
  symbol: string
  source: SignalSource
  side: SignalSide
  price: number
  quantity: number
  detected_at: string
  disappeared_at: string | null
  duration_seconds: number | null
  status: SignalStatus
  telegram_message_id: number | null
  telegram_channel_id: number | null
  dom_mode?: DomSignalType | null
}

export interface MonitoringSettings {
  dom_mode: DomMode
}

export interface SignalConfig {
  id: number
  signal_type: string
  threshold: number
  symbol: string
  channel_id: number
  is_active: boolean
  created_by: number | null
  created_at: string
}

export interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
  pages: number
}

export interface SignalListResponse extends PaginatedResponse<Signal> {}

export interface HealthResponse {
  status: string
  version: string
  database: boolean
  timestamp: string
}

// Auth types
export interface AuthStatusResponse {
  auth_enabled: boolean
  authenticated: boolean
  telegram_user_id?: number
  telegram_username?: string
}

export interface TokenVerifyResponse {
  valid: boolean
  telegram_user_id?: number
  telegram_username?: string
  expires_at?: string
}

// WebSocket message types
export type WebSocketMessageType = 'signal_new' | 'signal_disappeared' | 'ping' | 'pong'

export interface WebSocketMessage {
  type: WebSocketMessageType
  data?: Record<string, unknown>
  timestamp: string
}

// Binance candle data
export interface Candle {
  time: number // Unix timestamp in seconds
  open: number
  high: number
  low: number
  close: number
  volume: number
}

// Chart marker for signals
export interface SignalMarker {
  time: number
  position: 'aboveBar' | 'belowBar'
  color: string
  shape: 'circle' | 'square' | 'arrowUp' | 'arrowDown'
  text: string
  id: string
}

// Timeframe options
export type Timeframe = '1m' | '5m' | '15m' | '1h' | '4h' | '1d'

export const TIMEFRAMES: { value: Timeframe; label: string }[] = [
  { value: '1m', label: '1m' },
  { value: '5m', label: '5m' },
  { value: '15m', label: '15m' },
  { value: '1h', label: '1H' },
  { value: '4h', label: '4H' },
  { value: '1d', label: '1D' },
]
